import React from "react"

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__text">Copyrights © Metalkrat.pl</p>
      <p className="footer__text">
        Designed and built by{" "}
        <a href="https://mmotyka.pl/" target="_blank" rel="noreferrer">
          mmotyka.pl
        </a>
      </p>
    </footer>
  )
}

export default Footer
